import axios from 'axios';
import { getAxiosDefaultConfig } from 'utils'
import { baseUrl } from 'urls'
import _ from 'lodash'

export function setTeamMembers(teamMembers) {
  return {
    type: 'SET_TEAM_MEMBERS',
    payload: teamMembers,
  }
}

/**
 * Used to retrieve all team members in my team, including myself
 * @param {function} callback - Optional callback function
 */
export const getTeamMembers = (callback) => {
  return async (dispatch) => {
    dispatch({ type: 'SET_TEAM_MEMBERS_FETCH_STATUS', payload: true })
    try {
      const config = getAxiosDefaultConfig()
      const { data: teamMembers } = await axios.get(`${baseUrl}/invite/team_members`, config)
      dispatch(setTeamMembers(teamMembers))
      dispatch({ type: 'SET_TEAM_MEMBERS_FETCH_STATUS', payload: false })
      if (callback) {
        callback()
      }
    }
    catch(err) {
      const errMsg = _.get(err, ['response', 'data', 'errors'], 'Errors when fetching team members')
      console.error(errMsg)
      dispatch({ type: 'SET_TEAM_MEMBERS_ERROR', payload: errMsg })
    }
  }
}